<template>
  <b-card>
    <h2 class="text-[20px] text-[#222222] font-semibold">
      Report Performa Admin Marketplace
    </h2>
    <div class="flex items-center gap-[10px] my-[32px] flex-wrap justify-end">
      <div class="month-picker w-[140px] z-[1] ms-auto border-[1px] border-[#E2E2E2] flex justify-between rounded-[8px] items-center px-[5px] [&_.month-year-label]:py-[11px] [&_.month-year-label]:cursor-pointer [&_.month-year-label]:w-[140px] [&_.month-picker-wrapper]:-translate-x-[6px] [&_.month-picker-wrapper]:!min-w-0 [&_.date-popover]:min-w-[200px] [&_.date-popover]:!-translate-x-[calc(50%-15px)] [&_.date-popover]:!translate-y-4 [&_.vmp-clear-icon]:!grid [&_.vmp-clear-icon]:place-items-center [&_.vmp-clear-icon]:translate-x-[8px]">
        <MonthlyPicker
          v-model="filter.period"
          :month-labels="monthlabel"
          date-format="MMM YYYY"
          style="width: 100px; height: 40px;"
          input-class="border-0 w-[100px] h-full"
          clear-option
          :alignment="'center'"
          :selected-background-color="'#F95031'"
          :disabled="loading.list"
          place-holder="Periode"
        />
        <b-spinner
          v-if="loading.list"
          class="mr-[7px]"
          small
        />
        <span
          v-else
          class="k-calendar text-[24px] pr-[2px]"
        />
      </div>
      <VSelect
        v-model="filter.status"
        :reduce="e => e.value"
        :options="reportStatusOptions"
        label="text"
        clearable
        :disabled="loading.list"
        placeholder="Status"
        class="!text-[#333] w-[148px] shrink-0 [&>div]:h-[40px] [&>*]:!rounded-[8px]"
      />
      <b-input-group class="border-[1px] border-[#E2E2E2] h-[40px] !rounded-[8px] overflow-hidden max-w-[400px]">
        <template #prepend>
          <span class="flex h-full items-center pl-[12px]">
            <i class="k-search-normal-1 text-[24px]" />
          </span>
        </template>
        <b-form-input
          v-model="filter.search"
          type="search"
          class="!border-none !outline-none"
          placeholder="Cari talent, talent lead, nama atau id partner "
          debounce="500"
          :disabled="loading.list"
        />
      </b-input-group>
    </div>
    <BOverlay
      id="scroll"
      :show="loading.list"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity=".5"
      rounded="sm"
    >
      <BTable
        :items="items"
        :fields="fields"
        empty-text="Tidak ada data yang ditampilkan."
        responsive
        show-empty
        :small="true"
        class="h-[calc(100vh-308px)]"
        tbody-tr-class="hover:bg-slate-100 transition-colors duration-300 cursor-pointer"
        @scroll.native="handleScroll"
        @row-clicked="item => $router.push(`${$route.path}/${item.id}`)"
      >
        <template #cell(no)="data">
          {{ data.index + 1 }}
        </template>
        <template #cell(partner_name)="data">
          <div>
            <span class="text-[#333333]">{{ data.item.partner_name }}</span>
            <p class="text-[#828282] mt-[6px] mb-0">
              {{ data.item.partner_no }}
            </p>
          </div>
        </template>
        <template #cell(status)="data">
          <span
            class="h-[22px] w-[86px] grid place-items-center rounded-full border-[1px] font-medium text-[12px]"
            :class="statusColor(data.item.status)"
          >{{ statusLabel(data.item.status) }}</span>
        </template>
        <template #cell(action)="data">
          <router-link
            :to="`${$route.path}/${data.item.id}/preview`"
            target="_blank"
            class="text-[#08A0F7]"
          >
            Preview Report
          </router-link>
        </template>
      </BTable>
    </BOverlay>
  </b-card>
</template>

<script>
import { LABELMONTH, YEAR_MONTH } from '@/libs/filterDate'
import MonthlyPicker from 'vue-monthly-picker'
import VSelect from 'vue-select'
import '@core/scss/vue/libs/vue-select.scss'
import { komtimAxiosIns } from '@/libs/axios'
import { adminMarketplaceColumns, reportStatusOptions } from './config'

export default {
  components: { MonthlyPicker, VSelect },
  data() {
    return {
      filter: {
        period: null,
        search: '',
        status: '',
      },
      pagination: {
        limit: 20,
        offset: 0,
      },
      isLastData: false,
      monthlabel: LABELMONTH,
      loading: {
        list: false,
      },
      reportStatusOptions,
      fields: adminMarketplaceColumns,
      items: [],
    }
  },
  computed: {
    periode() {
      return this.filter.period ? YEAR_MONTH(this.filter.period) : null
    },
  },
  watch: {
    filter: {
      handler() {
        this.getReportList()
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.getReportList()
  },
  methods: {
    statusColor(status) {
      switch (status) {
        case 'verified': return 'text-[#10673E] bg-[#DCF3EB] border-[#34A770]'
        case 'revision': return 'text-[#E31A1A] bg-[#FFEDED] border-[#E31A1A]'
        default: return 'text-[#333333] bg-[#F4F4F4] border-[#C2C2C2]'
      }
    },
    statusLabel(status) {
      switch (status) {
        case 'verified': return 'Terverifikasi'
        case 'revision': return 'Revisi'
        default: return 'Diajukan'
      }
    },
    async getReportList({ isNext } = { isNext: false }) {
      if (this.loading.list || (isNext && this.isLastData)) return
      if (!isNext) this.pagination.offset = 0
      this.loading.list = true
      try {
        const { data: { data } } = await komtimAxiosIns.get('v1/admin_marketplace_performance/report', {
          params: { ...this.filter, ...this.pagination, period: this.periode },
        })
        this.isLastData = data && data.length < this.pagination.limit
        this.pagination.offset += data.length
        if (!isNext) {
          this.items = data
          return
        }
        this.items.push(...data)
      } catch (error) {
        this.alertError(error)
      } finally {
        this.loading.list = false
      }
    },
    handleScroll({ target }) {
      const { offsetHeight, scrollTop, scrollHeight } = target
      if (offsetHeight + scrollTop + 1 < scrollHeight) return
      this.getReportList({ isNext: true })
    },
  },
}
</script>
